import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  connect() {
    this.timeout = null
    this.initSlimSelects()
  }

  initSlimSelects() {
    // Project SlimSelect
    const projectSelect = this.element.querySelector(".slim-project")
    if (projectSelect) {
      new SlimSelect({
        select: projectSelect,
        allowDeselect: true,
        placeholder: "Choose a project",
        onChange: () => this.submitForm() // 🔥 instant filter
      })
    }

    // Property SlimSelect
    const propertySelect = this.element.querySelector(".slim-property")
    if (propertySelect) {
      new SlimSelect({
        select: propertySelect,
        allowDeselect: true,
        placeholder: "Choose a property",
        onChange: () => this.submitForm() // 🔥 instant filter
      })
    }
  }

  // Called when typing in number fields
  input(event) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submitForm(), 700) // 🕐 wait 700ms after typing stops
  }

  // Called when using select fields (or manual form change)
  change() {
    this.submitForm()
  }

  submitForm() {
    this.element.requestSubmit()
  }
}
